
import { Sale } from "@/models/base";
import { SaleService } from "@/services";
import { PreviewData } from "@/utils/reminder-layouts/preview-data";
import Vue from "vue";
import AppSaleSearchWithBrowse from "@/components/sales/SaleSearchWithBrowse.vue";

export default Vue.extend({
	data(){
		return {
			sale: null as null | Sale
		};
	},
	props: {
		settings: {
			type: Object as ()=>PreviewData,
			required: true
		},
	},
	methods: {
		async fetch(){
			if (this.settings.SaleID == 0) return;
			this.sale = await SaleService.getSale(this.settings.SaleID);
			this.settings.SaleID = this.sale.ID;
		},
		setSale(sale:Sale | null){
			this.sale = sale;
			if (!sale){
				this.settings.SaleID = 0;
			}else{
				this.settings.SaleID = sale.ID;
			}
		},
	},
	async mounted(){
		await this.fetch();
	},
	components: {
		AppSaleSearchWithBrowse
	}
});
